import { render, staticRenderFns } from "./EditBank.vue?vue&type=template&id=f51b8be6&"
import script from "./EditBank.vue?vue&type=script&lang=js&"
export * from "./EditBank.vue?vue&type=script&lang=js&"
import style0 from "./EditBank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports